<template lang="">
    <b-container fluid>
        <canvas
        :id="cctv._id"
        ></canvas>
    </b-container>
</template>
<script>
import JSMpeg from 'jsmpeg-player'
import axios from 'axios'
import { getUserData } from '@/auth/utils'
import store from '@/store'
import {
  BCard, BSpinner
} from 'bootstrap-vue'
export default {
    components: {
        BCard,
        BSpinner
    },
    props: {
     
    },
    data: () => {
        return {
            cctv: {},
            player: {},
            streamURL: `https://rtsp.e-farm.site/?port=${4000}`
        }
    },
    mounted() {

    },
    created() {
        this.init()
    },
    destroyed() {
        this.destroyCCTV()
    },
    methods: {

        async init() {
            const farms = await store.getters['farm/getFarmSelect'];
            const farm = farms[0]

            const cctvList = await store.dispatch('cctv/fetchCCTVs', {
                userId: await getUserData().id,
                farmId: farm.value
            })

            this.cctv = cctvList.data[0]
            console.log('Target CCTV :: ', this.cctv)
            this.cctv.rtspUrl = `rtsp://${this.cctv.account}:${this.cctv.password}@${this.cctv.rtspUrl}`
            let res = await axios.post(`${this.streamURL}/start`, this.cctv)
            if (res.data.result) {
                this.cctv.port = res.data.port;
                this.stream(this.cctv);
            }
        },
        async stream(cctv) {
            try {
                const canvas = document.getElementById(`${cctv._id}`);
                if (canvas) {
                    canvas.style.cssText = `
                        width: 100%;
                        background-color: black;
                        border-radius: 0.4rem;
                    `;
                    canvas.addEventListener('click', e => {
                        e.preventDefault();
                    });
                    
                    const player = new JSMpeg.Player(`wss://rtsp.e-farm.site/?port=${cctv.port}`, {
                        poster: '@/assets/logo.png',
                        disableGl: true,
                        loop: true,
                        canvas,
                        autoplay: true
                    });
                    this.player = { id: cctv._id, port: cctv.port, vPlayer: player }
                }
            } catch (error) {
                console.error("Stream failed: ", error);
            }
        },
        destroyCCTV () {
            axios.get(`${this.streamURL}/stop/${this.cctv.port}`)
            this.player.vPlayer.stop()
            this.player.vPlayer.destroy()
        }
    },
    
}
</script>
<style scoped>
.rotate {
    transform: rotate(90deg);
    transform-origin: center center;
}
</style>